import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from "react-redux";
import { Container, Row, Col, Image } from 'react-bootstrap';
import { RootState } from "../services/rootReducer";
import { selectMissionColorMap, selectGradientColorMap, selectGradient } from "../services/View_Slice";


import DoughnutChart from "./DoughnutChart";
import Gradient from "./Gradient";
import CONSTANTS from "../constants";
//import { startOfMonth, format } from 'date-fns';
import styles from "./css/Summary.module.css";
import logger from 'logger';

import { getMissionLifetime, getChartData, getDoughnutData, getGradientData } from "./utils/summaryHelper";
import colormap from "colormap";
import styled from "styled-components";
import InlineSpinner from './InlineSpinner';
interface Dictionary<T> {
    [Key: string]: T;
}

// new:aspectRatio: 1.5,
const theChartOptions={
    width: 100,
    height: 100,
    aspectRatio: 1.5,
    legend: {
      display: false,
      labels: {
          fontColor: '#495057'
      }
    },
    animation: {
        animateRotate: false,
        animateScale: false,
    },
    tooltips: {
        backgroundColor: CONSTANTS.UI.TOOLTIP_COLOR,
    }
};

const theChartOptions_mobile={
    width: 100,
    height: 100,
    aspectRatio: 2.7,
    legend: {
      display: false,
      labels: {
          fontColor: '#495057'
      }
    },
    animation: {
        animateRotate: false,
        animateScale: false,
    },
    tooltips: {
        backgroundColor: CONSTANTS.UI.TOOLTIP_COLOR,
    }
};


/*const theChartData = {
    labels: ['Toto: A', 'B', 'C'],
    datasets: [
        {
            data: [300, 50, 100],
            backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ],
            hoverBackgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ]
        }]
    }*/






type chartEntryType = {
    angle: number,
    label: string,
    color: string,
}

const CHART_FIELD=CONSTANTS.UI.CHART_DATA_0;
const CHART_FIELD1=CONSTANTS.UI.CHART_DATA_1;

const StyledDiv = styled.div`
    width : 14px!important;
    min-width: 14px!important;
    height: 14px!important;
    min-height: 14px!important;
    padding-top: 0px;
    padding-bottom: 5px;
    margin-top: 0px;
    margin-bottom: 5px;
    margin-left: 0px;
    margin-right: 10px;
    background-color: ${props => props.color};
    border-radius: 100%;
`;

type screenValues = {
    mobile: boolean,
    width: number
}


function Summary(props: React.PropsWithChildren<screenValues>) {
    // Individual color map selectors — avoids re-render when only the other color map changes
    const missionColorMap = useSelector(selectMissionColorMap);
    const gradientColorMap = useSelector(selectGradientColorMap);
    const { gradientValues, gradientLoading } = useSelector(selectGradient);

    const {numFound, facetFound, summaryRefreshing} = useSelector(
        (state: RootState) => ({
            numFound: state.Summary.numFound,
            facetFound: state.Summary.facetFound,
            summaryRefreshing: state.Summary.loading,
        }),
        shallowEqual
    );


    //
    const usedContainer = props.mobile ? styles.container_mobile: styles.container;
    const usedColStyle = props.mobile ? styles.col_mobile: styles.col;
    const usedTotalDivStyle = props.mobile ? styles.totalDiv_mobile: styles.totalDiv;
    const usedLegendDiv = props.mobile ? styles.legendDiv_mobile: styles.legendDiv;
    const usedDivLegendGrid = props.mobile ? styles.divLegendGrid_mobile: styles.divLegendGrid;
    const usedDivDoughnut = props.mobile ? styles.divDoughnut_mobile: styles.divDoughnut;

    // Memoize chart data calculations — only recalculate when facetFound, numFound, or color maps change
    const { missionInfo, doughnutData, gradientData } = useMemo(() => {
        var missionInfoCalc: Array<any> = [];
        var doughnutDataCalc: Array<any> = [];
        var gradientDataCalc: Array<any> = [];

        if(facetFound!==undefined && facetFound[CHART_FIELD1]!==undefined){
            missionInfoCalc = getChartData(facetFound, CHART_FIELD1);
            doughnutDataCalc = getDoughnutData(numFound, facetFound, CHART_FIELD1, missionColorMap);
            gradientDataCalc = getGradientData(numFound, gradientValues, gradientColorMap);
        }

        return { missionInfo: missionInfoCalc, doughnutData: doughnutDataCalc, gradientData: gradientDataCalc };
    }, [facetFound, numFound, missionColorMap, gradientValues, gradientColorMap]);



    /*var gradientData1 = {
        labels: ["2014", "2013", "2012", "2011"],
        
        datasets: [{
            label: 'Dataset 1',
            data: [727, 589, 537, 543, 574],
            backgroundColor: "rgba(63,103,126,1)",
            hoverBackgroundColor: "rgba(50,90,100,1)"
        },{
            label: 'Dataset 2',
            data: [238, 553, 746, 884, 903],
            backgroundColor: "rgba(163,103,126,1)",
            hoverBackgroundColor: "rgba(140,85,100,1)"
        },{
            label: 'Dataset 3',
            data: [1238, 553, 746, 884, 903],
            backgroundColor: "rgba(63,203,226,1)",
            hoverBackgroundColor: "rgba(46,185,235,1)"
        }]
    };*/


    // Memoize mission legend layout — only recalculate when missionInfo or colorMap changes
    const { missionToRender, legendRows } = useMemo(() => {
        // 2-column, column-major grid sized from the actual mission count.
        // The old fixed 10-slot math (row*2+col with row=i%5) collided for
        // i>=10 — an 11th mission overwrote an earlier slot and legend
        // entries silently vanished. For <=10 missions the mapping below is
        // identical to the old one (numRows=5).
        const missionKeys = missionInfo[2] ? Object.keys(missionInfo[2]) : [];
        const numRows = Math.max(5, Math.ceil(missionKeys.length / 2));
        const missions: Array<string> = Array(numRows * 2).fill('');
        missionKeys.forEach((aVar, i) => {
            const row = i % numRows;
            const col = Math.floor(i / numRows);
            missions[row * 2 + col] = aVar;
        });

        var nn: number=0;
        const cells = missions.map((item, slot) =>{
            nn+=1;
            // left-column cell with a mission next to it: its label may end in an ellipsis
            // on narrow screens instead of running into the neighbour's colour dot
            const hasRightNeighbour = slot % 2 === 0 && missions[slot + 1] !== '';
            return(
                <div key={nn} className={hasRightNeighbour ? usedLegendDiv + ' ' + styles.legendHasRight : usedLegendDiv}>
                    <StyledDiv color={missionColorMap[item]}></StyledDiv>
                    <div key={item}  className={styles.legendItem}>{item} {getMissionLifetime(item)}</div>
                </div>
            )
        });
        return { missionToRender: cells, legendRows: numRows };
    }, [missionInfo, missionColorMap, usedLegendDiv]);
    
    var lg = props.width < 1500 ? [5, 7, 5, 7]: [2, 4, 1, 5] 

    const summaryLoading = doughnutData[1] === undefined;
    const dimStyle: React.CSSProperties = { opacity: 0.5, pointerEvents: 'none' };
    const hasData = !summaryLoading && missionInfo !== undefined && missionInfo[0] && doughnutData[1]['labels'].length > 0;
    const isAnyLoading = summaryLoading || summaryRefreshing || gradientLoading;

    return (
        <Container className={usedContainer}>
            <div className={styles.loadingWrapper}>
            {isAnyLoading && <InlineSpinner />}
            <Row className={styles.row} style={isAnyLoading ? dimStyle : undefined}>

                {/* the files total */}
                <Col xs={12} md={5} lg={lg[0]} className={usedColStyle}>
                    <div className={styles.sectionWrapper}>
                        {!summaryLoading &&
                        <div>
                            <label className={styles.labelSmall}>Reports Number</label>
                            <div className={usedTotalDivStyle}>
                            <Image src="/qrast/images/doc-icon.png" alt="Total of documents" className={styles.glIcons}/>
                            <label className={styles.labelTotal}>{numFound} files</label>
                            </div>
                        </div>
                        }
                    </div>
                </Col>




                {hasData ?
                <>
                    {/* the mission list */}
                    <Col xs={12} md={7} lg={lg[1]} className={usedColStyle}>
                        <div className={styles.sectionWrapper}>
                            <div>
                                <label className={styles.labelSmall}>{CONSTANTS.UI.TOP_CAT_LABEL}</label>
                                <div
                                    className={usedDivLegendGrid}
                                    style={
                                        {
                                            '--legend-rows': legendRows,
                                        } as React.CSSProperties
                                    }
                                >
                                    {missionToRender}
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* the mission %  DoughnutChart */}
                    <Col xs={12} md={5} lg={lg[2]} className={usedColStyle}>
                        <div className={styles.sectionWrapper}>
                            <div>
                            <label className={styles.labelSmall}>% for Mission</label>
                            <div className={usedDivDoughnut}>
                                <DoughnutChart chartData={doughnutData[1]} chartOptions={props.mobile ? theChartOptions_mobile : theChartOptions}/>
                            </div>
                            </div>
                        </div>
                    </Col>

                    {/* the mission docType gradients */}
                    <Col xs={12} md={7} lg={lg[3]} className={usedColStyle}>
                        <div className={styles.sectionWrapper}>
                            <div>
                            <label className={styles.labelSmall}>Type of report</label>
                            <Gradient missionInfo={missionInfo} doughnutData={doughnutData}/>
                            </div>
                        </div>
                    </Col>
                </>
                :
                summaryLoading ?
                <>
                    {/* Initial load: empty placeholders preserve grid height */}
                    <Col xs={12} md={7} lg={lg[1]} className={usedColStyle}>
                        <div className={styles.sectionWrapper} />
                    </Col>
                    <Col xs={12} md={5} lg={lg[2]} className={usedColStyle}>
                        <div className={styles.sectionWrapper} />
                    </Col>
                    <Col xs={12} md={7} lg={lg[3]} className={usedColStyle}>
                        <div className={styles.sectionWrapper} />
                    </Col>
                </>
                :
                /* Empty state - no data available */
                <Col xs={12} md={7} lg={10} className={styles.emptyStateCol}>
                    <div className={styles.emptyState}>
                        No data available for the selected period
                    </div>
                </Col>
                }

                {/*</div>*/}
            </Row>
            </div>
        </Container>
    );
}

export default React.memo(Summary);